/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { HomeItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Download } from '../Download/Download';
import { Expires } from '../Expires/Expires';
import { Favorite } from '../Favorite/Favorite';
import { ItemName } from '../ItemName/ItemName';
import { ItemTip } from '../ItemTip/ItemTip';
import { Pic } from '../Pic/Pic';
import { Progress } from '../Progress/Progress';
import { Publish } from '../Publish/Publish';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface HomeProps extends HomeItemProps {
    checkboxClassname?: string;
    favoriteClassname?: string;
}

export const Home: FC<HomeProps> = (props) => {
    const { denyDoAction: isProgress, tipData, isFolder, checkboxClassname, favoriteClassname, progress, onCancelUpload } = props;

    return (
        <>
            <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
            <TableColumn>
                <Checkbox
                    className={checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                    isDisabled={isProgress}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    author={props.author}
                    isAutoDelete={props?.isAutoDelete}
                    publicExpires={props.publicExpires}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} loading={isProgress} />
            </TableColumn>
            {props.isFolder && Boolean(props.publicExpires) && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} />
                </TableColumn>
            )}
            {!props.isFolder && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Date date={props.mtime} />
                </TableColumn>
            )}
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            {!isProgress && (
                <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                    <Favorite
                        className={favoriteClassname}
                        isAvailable={!!props.favoritesAvailable}
                        isFavorite={!!props.isInFavorites}
                        onClick={props.onFavorites}
                    />
                    <Publish onClick={props.onPublish} isShared={props.isPublic} />

                    <Download
                        onClick={props.onDownload}
                        ext={props.isFolder ? 'zip' : props.ext}
                        size={props.size}
                        id={props.id}
                        storage={props.storage}
                    />
                </TableColumn>
            )}
            {isProgress && typeof progress === 'number' && (
                <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                    <Progress onClick={onCancelUpload} progress={progress} />
                </TableColumn>
            )}
        </>
    );
};
